// eslint-disable-next-line import/prefer-default-export
export const houseConsignmentDocumentQueryKeys = {
  byHouseConsignmentId: (houseConsignmentId: number | null) => ['v3/house-consignment', houseConsignmentId, 'documents'],
}
